import { ProductBuilderState, productBuilderStateInitial } from '../state'
import { createReducer } from '../../../core'
import { all } from 'redux-saga/effects'
import { productBuilderCostSet, productBuilderCostCalculateWatch } from './cost'
import { productBuilderParameterExpand, productBuilderParametersSet, productBuilderParameterExpandRequestedWatch, productBuilderParameterValueSelectWatch, productBuilderParameterValueDisabledSet, productBuilderParameterValueDisableReset, productBuilderParameterChanged } from './parameter'
import { productBuilderLoadingBegin, productBuilderLoadingEnd } from './loading'
import { productBuilderConfigurationSet } from './configuration'
import { productBuilderNotificationVisibilitySet } from './notification'
import { productBuilderStepIndexChange } from './step'
import { productBuilderProductSet, productBuilderProductLoadWatch, productBuilderDefaultProductSet } from './product'
import { productBuilderAddToCartWatch } from './cart'
import { productBuilderFileUploadWatch, productBuilderFileDeleteWatch } from './file'

export type ProductBuilderAction =
    | 'PRODUCT_BUILDER_ADD_TO_CART'
    | 'PRODUCT_BUILDER_CONFIGURATION_SET'
    | 'PRODUCT_BUILDER_COST_CALCULATE'
    | 'PRODUCT_BUILDER_COST_SET'
    | 'PRODUCT_BUILDER_FILE_UPLOAD'
    | 'PRODUCT_BUILDER_FILE_DELETE'
    | 'PRODUCT_BUILDER_LOADING_BEGIN'
    | 'PRODUCT_BUILDER_LOADING_END'
    | 'PRODUCT_BUILDER_PARAMETER_CHANGED'
    | 'PRODUCT_BUILDER_PARAMETER_EXPAND'
    | 'PRODUCT_BUILDER_PARAMETER_EXPAND_REQUEST'
    | 'PRODUCT_BUILDER_PARAMETER_VALUE_SELECT'
    | 'PRODUCT_BUILDER_PARAMETER_VALUE_DISABLED_RESET'
    | 'PRODUCT_BUILDER_PARAMETER_VALUE_DISABLED_SET'
    | 'PRODUCT_BUILDER_NOTIFICATION_VISIBILITY_SET'
    | 'PRODUCT_BUILDER_PARAMETERS_SET'
    | 'PRODUCT_BUILDER_PRODUCT_LOAD'
    | 'PRODUCT_BUILDER_PRODUCT_SET'
    | 'PRODUCT_BUILDER_STEP_INDEX_CHANGE'
    | 'PRODUCT_BUILDER_DEFAULT_PRODUCT_SET'


export const productBuilderReducer = createReducer<ProductBuilderState, ProductBuilderAction>(productBuilderStateInitial, [
    { action: 'PRODUCT_BUILDER_CONFIGURATION_SET', handler: productBuilderConfigurationSet },
    { action: 'PRODUCT_BUILDER_COST_SET', handler: productBuilderCostSet },
    { action: 'PRODUCT_BUILDER_LOADING_BEGIN', handler: productBuilderLoadingBegin },
    { action: 'PRODUCT_BUILDER_LOADING_END', handler: productBuilderLoadingEnd },
    { action: 'PRODUCT_BUILDER_NOTIFICATION_VISIBILITY_SET', handler: productBuilderNotificationVisibilitySet },
    { action: 'PRODUCT_BUILDER_PARAMETER_CHANGED', handler: productBuilderParameterChanged },
    { action: 'PRODUCT_BUILDER_PARAMETER_EXPAND', handler: productBuilderParameterExpand },
    { action: 'PRODUCT_BUILDER_PARAMETER_VALUE_DISABLED_RESET', handler: productBuilderParameterValueDisableReset },
    { action: 'PRODUCT_BUILDER_PARAMETER_VALUE_DISABLED_SET', handler: productBuilderParameterValueDisabledSet },
    { action: 'PRODUCT_BUILDER_PARAMETERS_SET', handler: productBuilderParametersSet },
    { action: 'PRODUCT_BUILDER_PRODUCT_SET', handler: productBuilderProductSet },
    { action: 'PRODUCT_BUILDER_STEP_INDEX_CHANGE', handler: productBuilderStepIndexChange },
    { action: 'PRODUCT_BUILDER_DEFAULT_PRODUCT_SET', handler: productBuilderDefaultProductSet },
])

export function* productBuilderSaga() {
    yield all([
        productBuilderAddToCartWatch(),
        productBuilderCostCalculateWatch(),
        productBuilderFileDeleteWatch(),
        productBuilderFileUploadWatch(),
        productBuilderParameterExpandRequestedWatch(),
        productBuilderParameterValueSelectWatch(),
        productBuilderProductLoadWatch()
    ])
}
